import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// IMPORT Bootstrap
import 'bootstrap'

import 'animate.css'

// AV PLUGIN
import AudioVisual from 'vue-audio-visual'

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

// Vue Scroll
import VueScrollTo from 'vue-scrollto'

Vue.use(AudioVisual)
Vue.use(VuePlyr, {
  plyr: {
    captions: {
      active: true
    }
  }
})
Vue.use(VueScrollTo)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
